import React, { memo, useEffect, useRef } from 'react';
import { Button, CircularProgress } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import './customButton.scss';
export const CustomButton = memo(({
    label,
    variant = 'contained',
    onClick,
    isLoading = false,
    disabled,
    endIcon,
    startIcon,
    children,
    size = 'medium',
    nextArrow,
    previousArrow,
    outlinedGray,
    fullWidth,
    noOutline,
    className,
    ...props
}) => {

    const debounceRef = useRef(null);
    const outlinedVariant = variant === 'outlined';

    const handleClick = (e) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(() => {
            onClick(e)
        }, 300); // Aquí definimos el tiempo de "debounce"

    }

    return (
        <div className='custom-button-container'>
            <Button
                {...props}
                className={
                    `custom-button 
                    ${(outlinedVariant && outlinedGray) && 'outlined-gray'}
                    ${(outlinedVariant && noOutline) && 'no-outline'}
                    ${className}`
                }
                variant={variant}
                fullWidth={fullWidth}
                size={size}
                disableRipple
                onClick={handleClick}
                disabled={disabled || isLoading}
                startIcon={previousArrow ? <KeyboardArrowLeftIcon /> : startIcon}
                endIcon={nextArrow ? <KeyboardArrowRightIcon /> : endIcon}
            >
                {!isLoading && (children || label)}
                {isLoading && <CircularProgress size={20} color='inherit' />}
            </Button>
        </div>
    )
})